import { render, staticRenderFns } from "./MarketplaceContractDocuments.vue?vue&type=template&id=70f67828&scoped=true&"
import script from "./MarketplaceContractDocuments.vue?vue&type=script&lang=js&"
export * from "./MarketplaceContractDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f67828",
  null
  
)

export default component.exports